<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader class="p-1">
            <CRow>
              <CCol col="8" style="text-align: start ;padding:10px 20px 0 20px ">

                <strong v-if="status_form==0">{{ $t('modules.production') }}</strong>

              </CCol>
              <CCol col="4" style="text-align: end">


                <CButton v-if="status_form==0" class="mr-1 ml-1"  @click="insert_data()" type="submit" size="sm" color="secondary">
                  {{ $t('buttons.submit') }}
                </CButton>

                <CButton
                    class="mr-1"
                    size="sm"
                    color="secondary"
                >{{ $t("buttons.cancel") }}
                </CButton>

              </CCol>
            </CRow>
          </CCardHeader>
          <CCardBody>
            <CTabs>
              <CTab  :title="$t('modules.productionCategory')"></CTab>
              <CTab  :title="$t('modules.BOM')"></CTab>
              <CTab  :title="$t('modules.productionInfo')"></CTab>
              <CTab  :title="$t('modules.productionDeal')"></CTab>
              <CTab  :title="$t('modules.productionList')"></CTab>
              <CTab  :title="$t('modules.productionDealList')"></CTab>

            </CTabs>


          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';



export default {
  name: 'Login',
  data() {
    return {

      status_form: 0
    }
  }, mounted() {

  }, watch: {

  },
  methods: {

  }
}

</script>
